var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "gh-sidebar-fade" } }, [
    _vm.isOpen
      ? _c("div", { staticClass: "gh-sidebar-root" }, [
          _c(
            "aside",
            {
              staticClass: "gh-sidebar",
              class: {
                "gh-sidebar--collapsed": !_vm.isExpanded,
                "gh-sidebar--resizing": _vm.isResizing,
              },
              style: _vm.sidebarStyle,
              attrs: {
                role: "dialog",
                "aria-modal": "false",
                "aria-label": _vm.$t("generation_history.history"),
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm.isExpanded
                ? _c("div", {
                    staticClass: "gh-sidebar__resize-handle",
                    attrs: { role: "separator" },
                    on: {
                      mousedown: function ($event) {
                        $event.preventDefault()
                        return _vm.startResize.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "gh-sidebar__expand-btn",
                  attrs: { type: "button" },
                  on: { click: _vm.toggleExpanded },
                },
                [
                  _c("i", {
                    class: _vm.isExpanded
                      ? "fa fa-chevron-right"
                      : "fa fa-chevron-left",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "gh-sidebar__inner" },
                [
                  _vm.view === "list"
                    ? [
                        _c("header", { staticClass: "gh-sidebar__header" }, [
                          _c("div", { staticClass: "gh-sidebar__tabs" }, [
                            _c(
                              "button",
                              {
                                staticClass: "gh-sidebar__tab",
                                class: {
                                  "is-active": _vm.activeTab === "history",
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setActiveTab("history")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("generation_history.history")
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "gh-sidebar__tab",
                                class: {
                                  "is-active": _vm.activeTab === "favorites",
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setActiveTab("favorites")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "generation_history.favorites_list"
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "gh-sidebar__close",
                              attrs: { type: "button" },
                              on: { click: _vm.closeSidebar },
                            },
                            [_c("span", [_vm._v("×")])]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.activeTab === "favorites"
                          ? _c("GenerationHistoryFavoritesListView")
                          : _c("GenerationHistoryListView"),
                      ]
                    : _c("GenerationHistoryDetailView"),
                ],
                2
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }